import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import MyJobList from './MyJobList';
import * as basketActions from '../../../../../actions/transactions/basket';
import * as purchaseActions from '../../../../../actions/transactions/purchases';
import { NoResults } from '../../../../common/elements';
import * as jobsActions from '../../../../../actions/jobs/jobs';
import * as commonActionsSearch from '../../../../../actions/common/search';
import Loader from '../../../../common/elements/Loader';
import ThemePageBanner from '../../../../dashboardNew/components/ThemePageBanner';

class MyJobsPage extends Component {
	componentDidMount() {
		const { location, getMyJobs, getProducts, getLocations, getExpertise, getIndustries, getRemunerationTypes, getSectors, myJobs } = this.props;
		const personId = localStorage.getItem('person_id');
		const page = location.query.page;

		!myJobs ? getMyJobs(personId, page ? page : 1) : null;
		getProducts();
		getLocations();
		getExpertise();
		getIndustries();
		getRemunerationTypes();
		getSectors();
	};

	reloadPage = () => this.props.getMyJobs(localStorage.getItem('person_id'), this.props.location.query.page ? this.props.location.query.page : 1)
	addJobToFavourites = (jobId, index) => this.props.addJobToFavourites(localStorage.getItem('person_id'), jobId, index)
	removeJobFromFavourites = (jobId, index) => this.props.removeJobFromFavourites(localStorage.getItem('person_id'), jobId, index)
	jobList = () => <MyJobList addJobToFavourites={this.addJobToFavourites} removeJobFromFavourites={this.removeJobFromFavourites} jobs={this.props.myJobs} />

	render() {
		if (this.props.myJobs === 'loading') { return <Loader /> };
		return (
			<article className="jobs-body">
				<main className="main--jobs">
					<ThemePageBanner
						image='/images/myJobs.jpg'
						heading='My Jobs'
					/>
					<section className="section jobs-body__search-results  margin-top">
						<div className="container">
							<div className="row">
								<div className="col-xs-12">
									<div className="text-center margin-bottom">
										<button className="theme-button" type="button" onClick={() => this.props.router.push(`/account/jobs-and-member-preferences`)}>
											Set job alert and member search preferences{' '}
											<span className="icon hidden-xs"><i className="fa fa-bell-o fa-right" /></span>
										</button>
									</div>
									{!this.props.myJobs || !this.props.myJobs.length ? <NoResults /> : this.jobList(this.props.myJobs)}
								</div>
							</div>
						</div>
					</section>
				</main>
			</article>
		);
	}
}

const mapStateToProps = state => ({
	myJobs: state.jobs.myJobs,
	basket: state.transactions.basket,
	originalProducts: state.transactions.products,
	locations: state.search.locations,
	expertise: state.search.expertise,
	industries: state.search.industries,
	remuneration_types: state.search.remuneration_types,
	sectors: state.search.sectors,
	options: state.jobs.options,
	formValues: state.form.search_form,
	noAdInSlot: state.googledfp.noAdInSlot,
	dfpMPU: state.googledfp.dfp_data,
});

const mapDispatchToProps = dispatch => ({
	getMyJobs: (personId, page) => dispatch(jobsActions.getMyJobs(personId, page)),
	addProductToBasket: (productId) => dispatch(basketActions.addProductToBasket(productId)),
	getProducts: (networkId) => dispatch(purchaseActions.getProducts(networkId)),
	getLocations: () => dispatch(commonActionsSearch.getLocations()),
	getExpertise: () => dispatch(commonActionsSearch.getExpertise()),
	getIndustries: () => dispatch(commonActionsSearch.getIndustries()),
	getRemunerationTypes: () => dispatch(commonActionsSearch.getRemunerationTypes()),
	getSectors: () => dispatch(commonActionsSearch.getSectors()),
	unmountJobs: () => dispatch(jobsActions.unmountJobs()),
	addJobToFavourites: (personId, jobId, index) => dispatch(jobsActions.addJobToFavourites(personId, jobId, index)),
	removeJobFromFavourites: (personId, jobId, index) => dispatch(jobsActions.removeJobFromFavourites(personId, jobId, index)),
	saveSearch: (personId, searchValues, flag) => dispatch(jobsActions.saveSearch(personId, searchValues, flag)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyJobsPage));



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/MyJobsPage.js